<style lang="scss">
.termsOfUse {
  background: transparent;
  margin: 3rem auto;
  max-width: 900px;

  &__title {
    margin-bottom: 2rem;
  }

  &__wrapper {
    background: transparent;
  }
}
</style>

<template>
  <section class="termsOfUse">
    <h3 class="termsOfUse__title">Termos de Uso</h3>

    <article v-html="termsOfUse" class="termsOfUse__wrapper" />
  </section>
</template>

<script>
import tos from '@/data/miscData/tos'

export default {
  name: 'DrTermsOfUse',

  data () {
    return {
      termsOfUse: tos
    }
  },

  mounted () {
    this.fn_HIDE_PROGRESS()

    this.$nextTick(() => {
      document.querySelector('#app').style.backgroundColor = 'white'
    })
  }
}
</script>
